export const getGoogleMapEmbedUrl = (
  lat: number,
  lon: number,
  zoom = 10,
): string =>
  `https://www.google.com/maps?q=${lat},${lon}&z=${zoom}&output=embed`;
